import { $_DKD, $_GCD, $_CD } from '@/confs/common.const.js';
import commonApi from "@/apis/common.api.js";

export default {
    state: {
        indicatorCodeList: [],
        seoulHjdCodeList: [],
    },
    getters: {
        getIndicatorCodeList(state) {
            return state.indicatorCodeList;
        },
        getSeoulHjdCodeList(state) {
            return state.seoulHjdCodeList;
        },
    },
    mutations: {
        INDICATOR_CODE_LIST(state, indicatorCateList) {
            state.indicatorCodeList = indicatorCateList;
        },
        SEOUL_HJD_CODE_LIST(state, seoulHjdCodeList) {
            state.seoulHjdCodeList = seoulHjdCodeList;
        },
    },
    actions : {
        FETCH_INDICATOR_CODE_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($_CD.INDICATOR_CATEGORY)
                .then((res)=>{
                    commit("INDICATOR_CODE_LIST", res.data.data);
                });
        },
        FETCH_SEOUL_HJD_CODE_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($_CD.DATA_SEOUL_HJDCD)
                .then((res)=>{
                    commit("SEOUL_HJD_CODE_LIST", res.data.data);
                });
        },
    },
};
